import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import { bem } from 'helpers/class-name';
import Confirm from 'components/Confirm';
import { Input } from 'components/Form';
import Message from 'components/Message';
import messages from '../../ScheduleForm.messages';
import './AddInstructorModal.scss';

const { block } = bem('add-instructor-modal');

const AddInstructorModal = ({ handleSubmit }) => (
  <Confirm
    cancelNode={<Message message={messages.modals.cancel} />}
    acceptNode={<Message message={messages.modals.save} />}
    title={<Message message={messages.modals.addInstructor.title} />}
    className={block()}
    isOpen
    onConfirm={handleSubmit}
    size="complex">
    <div className="grid">
      <div className="grid__item">
        <Field
          id="firstName"
          name="firstName"
          type="text"
          component={Input}
          label={messages.modals.addInstructor.labelFirstName}
        />
      </div>
      <div className="grid__item">
        <Field
          id="lastName"
          name="lastName"
          type="text"
          component={Input}
          label={messages.modals.addInstructor.labelLastName}
          optional
        />
      </div>
    </div>
  </Confirm>
);

AddInstructorModal.propTypes = {
  handleSubmit: PropTypes.func,
};

export default AddInstructorModal;
